import React from 'react';
import { Alert, Button, Spin, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  isUnreadForUser,
  STATUS_LABEL,
  SupportTicketStatus,
  SupportTicketSummary,
} from '../../services/supportApi';
import { formatRelative } from './format';
import * as S from './styles';

export const STATUS_COLOR: Record<SupportTicketStatus, string> = {
  OPEN: 'gold',
  IN_PROGRESS: 'blue',
  RESOLVED: 'green',
  CLOSED: 'default',
};

interface Props {
  tickets: SupportTicketSummary[];
  loading: boolean;
  error: string | null;
  onOpen: (id: string) => void;
  onNew: () => void;
}

const TicketList: React.FC<Props> = ({ tickets, loading, error, onOpen, onNew }) => (
  <>
    <S.Body>
      {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 10 }} />}
      {loading && tickets.length === 0 ? (
        <S.Empty>
          <Spin />
        </S.Empty>
      ) : tickets.length === 0 ? (
        <S.Empty>
          No tickets yet.
          <br />
          Found a bug or need a hand? Send us a report with a screenshot or a screen recording.
        </S.Empty>
      ) : (
        tickets.map((t) => {
          const unread = isUnreadForUser(t);
          return (
            <S.TicketRow
              key={t.id}
              $unread={unread}
              onClick={() => onOpen(t.id)}
              aria-label={`${t.subject}${unread ? ' (unread)' : ''}`}
            >
              <S.TicketRowTop>
                <S.TicketSubject $unread={unread}>{t.subject}</S.TicketSubject>
                <Tag color={STATUS_COLOR[t.status]} style={{ marginInlineEnd: 0 }}>
                  {STATUS_LABEL[t.status]}
                </Tag>
              </S.TicketRowTop>
              <S.TicketMeta>
                <S.TicketPreview>
                  {t.lastSenderRole === 'ADMIN' ? 'Support: ' : 'You: '}
                  {t.lastMessageText ?? ''}
                </S.TicketPreview>
                <span>{formatRelative(t.lastMessageAt)}</span>
              </S.TicketMeta>
            </S.TicketRow>
          );
        })
      )}
    </S.Body>
    <S.Footer>
      <Button type="primary" block icon={<PlusOutlined />} onClick={onNew}>
        New report
      </Button>
    </S.Footer>
  </>
);

export default TicketList;
